import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import PartidoService from '../../../../../services/partido-auth';
import { Link, useParams, Navigate } from 'react-router-dom';
import Moment from 'moment';






const Partido = () => {
    let { id } = useParams()

    const [ano, setAno] = useState("");
    const [dataCad, setDataCad] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    async function fetchPartido(id) {
        const response = await PartidoService.partidoEdit(id);
        Moment.locale();
        setAno(response.data["ano"]);
        setDataCad(Moment(response.data["dataCad"]).utc(false).format("yyyy-MM-DD"));
    }

    useEffect(() => {
        fetchPartido(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const partido = await PartidoService.editar(id, {
                ano: ano,
                dataCad: dataCad
            })
            if (partido.data["ano"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={4}>
                        <Col>
                            <Form.Group className="mb-3" controlId="ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="ano"
                                        value={ano}
                                        onChange={e => setAno(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="DataCad">
                                <FloatingLabel
                                    label="Data de Lançamento"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="dataCad"
                                        value={dataCad}
                                        onChange={e => setDataCad(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/partido/listar'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Liberação de Recurso editada com sucesso!</Alert>
                <Navigate to={'/restrito/partido/listar'} />
            </Fragment>
        )
    }
}

export default Partido;